import { render, staticRenderFns } from "./backupReport1.vue?vue&type=template&id=20345b62"
import script from "./backupReport1.vue?vue&type=script&lang=js"
export * from "./backupReport1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports